import { useMatch } from 'react-router';
import { Paths } from 'shared/routes/paths';

export const useIsProjectRoute = (): boolean =>
  !!useMatch({ path: Paths.ProjectDetail, end: false });
